import styled from "styled-components"


export const HooksPage = () => {
  return (
    <StyleWrap>
      HooksPage
    </StyleWrap>
  )
}

const StyleWrap = styled.div`

`;